<div class="row row-sm">
    <div class="col-lg-12">

        <div class="card-body">
            <!-- *ngIf="submitButton" -->
            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                    Caste

                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Add New Caste Record

                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                Caste
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Update New Caste Record
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                Caste </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                Delete New Caste Record
                            </p>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row row-sm add-form ">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="CategoryForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width hidden">
                                                <mat-label>
                                                    Code Type
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="25" placeholder="Code Type"
                                                    formControlName="CdType" matInput >
                                                    <!-- <mat-error class="margin_tp"
                                                    *ngIf="CategoryForm.controls['CdType'].touched && CategoryForm.controls['CdType'].errors?.required">
                                                    Mandatory
                                                </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width hidden">
                                                <mat-label>
                                               Code Description
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="25" placeholder="Description"
                                                    formControlName="CdDesc" matInput >
                                                    <mat-error class="margin_tp"
                                                    *ngIf="CategoryForm.controls['CdDesc'].touched && CategoryForm.controls['CdDesc'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                Code
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" [readonly]="isread || isreaddelete" class="color" type="text"
                                                    maxlength="6" placeholder="Code Name"
                                                    formControlName="CdCode" matInput >
                                                    <mat-error class="margin_tp"
                                                    *ngIf="CategoryForm.controls['CdCode'].touched && CategoryForm.controls['CdCode'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                    *ngIf="CasteForm.controls['CasteName'].touched && CasteForm.controls['CasteName'].errors?.pattern">
                                                    Invalid
                                                </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                Description
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="50" placeholder="Description"
                                                    formControlName="CdDesc" matInput >
                                                    <mat-error class="margin_tp"
                                                    *ngIf="CategoryForm.controls['CdDesc'].touched && CategoryForm.controls['CdDesc'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                    *ngIf="CasteForm.controls['CasteName'].touched && CasteForm.controls['CasteName'].errors?.pattern">
                                                    Invalid
                                                </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 prpl">
                                    <div class="col-sm-12">
                                        <!--  -->
                                        <!--  -->
                                        <button id="Save" type="button" *ngIf="submitButton"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="submit()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 5px;">
                                                Save
                                            </span>
                                        </button>
                                        <!--  -->
                                        <!--  -->
                                        <button id="Update" type="button" *ngIf="editButton"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 5px;">
                                                Update
                                            </span>
                                        </button>
                                        <!--  -->
                                        <!-- -->
                                        <button id="Delete" type="button" *ngIf="deleteButton" 
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1"
                                            (click)="openConformationModalBox()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/trash.gif"
                                                    style="margin-right: 5px;">
                                                Delete
                                            </span>
                                        </button>
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="20vh"  src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                Back
                                            </span>
                                        </button>

                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>